<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
};
</script>

<style scoped>

</style>
